export default "__VITE_ASSET__DR4F38c3__"